import PropTypes from "prop-types";
import React__default from "react";
import { Box } from "@mui/material";
import { COLORS } from "../../EatClubTheme.js";
const Divider = ({
  color = COLORS.CLOUD,
  mb = 0,
  mt = 0,
  style = {},
  direction = "horizontal"
}) => {
  const colorToUse = (style == null ? void 0 : style.color) ?? color;
  return /* @__PURE__ */ React__default.createElement(
    Box,
    {
      style: {
        borderBottom: direction === "horizontal" ? `1px solid ${colorToUse}` : "none",
        borderRight: direction === "vertical" ? `1px solid ${colorToUse}` : "none",
        width: direction === "horizontal" ? `100%` : "1px",
        height: direction === "vertical" ? `auto` : "1px",
        marginTop: mt,
        marginBottom: mb,
        ...style
      }
    }
  );
};
Divider.propTypes = {
  color: PropTypes.string,
  mb: PropTypes.number,
  mt: PropTypes.number,
  style: PropTypes.shape({}),
  direction: PropTypes.string
};
export {
  Divider
};
//# sourceMappingURL=Divider.js.map
